import { ArrowRight, ChevronDown } from "lucide-react";
import { Button } from "../ui/button";
import { companyInfo, logos, stats } from "../../data/mock";

export const HeroSection = () => {
  const scrollTo = (id) => {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background layers */}
      <div className="absolute inset-0 bg-[#050510]">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(0,119,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,119,255,0.03)_1px,transparent_1px)] bg-[size:64px_64px]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] bg-[radial-gradient(circle,rgba(0,119,255,0.07)_0%,transparent_60%)]" />
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] bg-[radial-gradient(circle,rgba(0,200,255,0.04)_0%,transparent_60%)]" />
        <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#080815] to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-24 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-20">
          {/* Text */}
          <div className="flex-1 space-y-8 hero-animate">
            <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full border border-[#0077FF]/20 bg-[#0077FF]/[0.05]">
              <span className="w-2 h-2 rounded-full bg-[#0077FF] animate-pulse" />
              <span className="text-xs font-semibold text-[#42baff] tracking-widest uppercase">
                Innovación & Tecnología
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-[3.5rem] xl:text-6xl font-bold text-white leading-[1.1] tracking-tight">
              {companyInfo.tagline}
            </h1>

            <p className="text-lg text-white/40 max-w-xl leading-relaxed">
              {companyInfo.subtitle}
            </p>

            <div className="flex flex-wrap gap-4 pt-2">
              <Button
                onClick={() => scrollTo("#servicios")}
                className="bg-[#0077FF] hover:bg-[#0060DD] text-white px-8 h-13 text-base rounded-lg transition-colors duration-300 group"
              >
                Nuestros Servicios
                <ArrowRight
                  size={18}
                  className="ml-2 group-hover:translate-x-1 transition-transform duration-300"
                />
              </Button>
              <Button
                onClick={() => scrollTo("#contacto")}
                variant="outline"
                className="border-white/10 text-white hover:bg-white/[0.04] hover:border-white/20 px-8 h-13 text-base rounded-lg transition-colors duration-300"
              >
                Solicitar Presupuesto
              </Button>
            </div>
          </div>

          {/* Logo visual */}
          <div className="flex-shrink-0 relative hero-animate-delay">
            <div className="relative w-60 h-60 lg:w-80 lg:h-80">
              <div className="absolute inset-0 rounded-full border border-[#0077FF]/10 animate-[spin_30s_linear_infinite]" />
              <div className="absolute inset-4 rounded-full border border-[#0077FF]/[0.07]" />
              <div className="absolute inset-8 rounded-full bg-[#0077FF]/[0.03]" />
              <div className="absolute inset-0 flex items-center justify-center">
                <img
                  src={logos.icon}
                  alt="InnovArs Microsistemas"
                  className="w-40 h-40 lg:w-52 lg:h-52 object-contain drop-shadow-[0_0_40px_rgba(0,119,255,0.25)] hero-float"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/[0.05] pt-12">
          {stats.map((stat, i) => (
            <div key={i} className="group">
              <p className="text-3xl lg:text-4xl font-bold text-white tracking-tight">
                {stat.value}
              </p>
              <p className="text-sm text-white/30 mt-1.5">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Scroll indicator */}
        <div className="hidden lg:flex absolute bottom-10 left-1/2 -translate-x-1/2 flex-col items-center gap-2">
          <span className="text-[11px] text-white/20 tracking-[0.2em] uppercase font-medium">
            Explorar
          </span>
          <ChevronDown size={18} className="text-white/20 animate-bounce" />
        </div>
      </div>
    </section>
  );
};
